import React from 'react';
import { FormGroup, TextField } from '@mui/material';
import { BlockFormState } from '../../types';

interface LayoutSTabProps {
    kedo: any;
    state: BlockFormState;
    handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const LayoutSTab: React.FC<LayoutSTabProps> = ({
    kedo,
    state,
    handleChange,
}) => {
    return (
        <FormGroup>
            <TextField
                size="small"
                fullWidth
                label={kedo.t('Column width')}
                name="col"
                value={state.item.col || 12}
                onChange={handleChange}
                error={!!(state.errors && state.errors.col)}
                helperText={state.errors && state.errors.col}
                margin="normal"
                type="number"
                minRows={1}
                maxRows={12}
            />
            <TextField
                size="small"
                fullWidth
                label={kedo.t('Rank')}
                name="rank"
                value={state.item.rank}
                onChange={handleChange}
                error={!!(state.errors && state.errors.rank)}
                helperText={state.errors && state.errors.rank}
                margin="normal"
                type="number"
            />
        </FormGroup>
    );
};

export default LayoutSTab;